import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/front-end-jobs">Front-end Remote Job</Link>
          <Link to="/front-end-jobs-interns">Front-end Interns Remote Job</Link>
          <Link to="/backend-jobs">Backend Remote Job</Link>
          <Link to="/fullstack-jobs">Fullstack Remote Job</Link>
          <Link to="/ui-jobs">UI Remote Job</Link>
          <Link to="/mobile-dev-jobs">Mobile Development Remote Job</Link>
          <Link to="/data-sci-jobs">Data Science Remote Job</Link>
          <Link to="/devops-jobs">DevOps Remote Job</Link>
          <Link to="/react-dev-jobs">React Developer Job</Link>
          <Link to="/react-native-dev-jobs">React Native Developer Job</Link>
          <Link to="/python-dev-jobs">Python Developer Job</Link>
          <Link to="/html-css-dev-jobs">HTML/CSS Developer Job</Link>
          <Link to="/javascript-dev-jobs">JavaScript Developer Job</Link>
          <Link to="/ruby-dev-jobs">Ruby Developer Job</Link>
          <Link to="/java-dev-jobs">Java Developer Job</Link>
          <Link to="/php-jobs">PHP Developer Job</Link>
          <Link to="/cloud-dev-jobs">Cloud Developer Job</Link>
          <Link to="/blockchain-dev-jobs">Blockchain Developer Job</Link>
          <Link to="/game-dev-jobs">Game Developer Job</Link>
          <Link to="/iot-dev-jobs">IoT Developer Job</Link>
          <Link to="/machine-learning-jobs">Machine Learning Job</Link>
          {/* Add more job categories as needed */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
